import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_campaign_line_RowClass } from '../../../dbschema/bl_dgmkt_campaign_line.model';

export class DgMktCampaignLineContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_line: bl_dgmkt_campaign_line_RowClass =
    new bl_dgmkt_campaign_line_RowClass();
}
